import RichTextEditor from '../wiki/RichTextEditor';

/**
 * CustomSectionBuilder - WYSIWYG editor for custom HTML sections
 * Uses the enhanced Tiptap editor shared with Wiki items
 */
export default function CustomSectionBuilder({ content, onContentChange, teamId }) {
  return (
    <div className="space-y-3">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Custom Content
        </label>
        <RichTextEditor
          content={content}
          onChange={onContentChange}
          placeholder="Add custom HTML content here..."
          className="min-h-[200px]"
          teamId={teamId}
        />
      </div>

      <p className="text-xs text-gray-500">
        Use the editor above to create custom content for this section. You can add formatted text, lists, and more.
      </p>

      {/* Template Library (future enhancement) */}
      <details className="text-xs text-gray-600">
        <summary className="cursor-pointer font-medium">Quick Templates</summary>
        <div className="mt-2 space-y-1">
          <button
            onClick={() => onContentChange('<h2>Important Announcement</h2><p>Your announcement text here...</p>')}
            className="block w-full text-left px-2 py-1 hover:bg-gray-100 rounded"
          >
            📢 Announcement
          </button>
          <button
            onClick={() => onContentChange('<h2>Contact Information</h2><ul><li><strong>Coach:</strong> Name (phone)</li><li><strong>Manager:</strong> Name (email)</li></ul>')}
            className="block w-full text-left px-2 py-1 hover:bg-gray-100 rounded"
          >
            📞 Contact List
          </button>
          <button
            onClick={() => onContentChange('<h2>Important Links</h2><ul><li><a href="#">Link 1</a></li><li><a href="#">Link 2</a></li></ul>')}
            className="block w-full text-left px-2 py-1 hover:bg-gray-100 rounded"
          >
            🔗 Link List
          </button>
        </div>
      </details>
    </div>
  );
}

